"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getVatNumberFormat = exports.getVatNumberRegex = exports.isValidEUVatNumber = exports.isvalidVatNumber = exports.isBlockedVatNumber = exports.vatBlockList = void 0;
var vatNumberFormatMap = {
    AT: {
        business: {
            example: 'ATU12345678',
            format: /^ATU\d{8}$|^AT U\d{8}$|^\d{2}\s\d{3}\/\d{4}$|^EU/,
        },
    },
    BE: {
        business: {
            example: 'BE1234567890',
            format: /^BE\d{10}$|^BE\s0\d{9}$|^EU/,
        },
    },
    BG: {
        business: {
            example: 'BG1234567890',
            format: /^BG\d{9,10}$/,
        },
    },
    CH: {
        business: {
            example: 'CH123 123',
            format: /^(CH)?\d{3}(\s)?\d{3}$|^CHE-?\d{3}\.?\d{3}\.?\d{3}(\s)?(((HR\/?)?MWST)|((RC\/?)?(TVA|IVA)))?$/,
        },
    },
    CN: {
        business: {
            example: '1234567890',
            format: /^\w{8,30}$/,
        },
    },
    CY: {
        business: {
            example: 'CY12345678901',
            format: /^CY\d{11}$/,
        },
    },
    CZ: {
        business: {
            example: 'CZ1234567890',
            format: /^CZ\d{8,10}$/,
        },
    },
    DE: {
        business: {
            example: 'DE123456789',
            format: /^DE\d{9}$|^\d{11}$|^EU/,
        },
    },
    DK: {
        business: {
            example: 'DK12345678',
            format: /^(DK)?\d{8}$|^EU/,
        },
    },
    EE: {
        business: {
            example: 'EE123456789',
            format: /^EE\d{9}$/,
        },
    },
    EL: {
        business: {
            example: 'EL123456789',
            format: /^EL\d{9}$/,
        },
    },
    ES: {
        business: {
            example: 'ESA1234567A',
            format: /^(ES)?[A-Z0-9]\d{7}[A-Z0-9]$|^EU/,
        },
        private: {
            example: 'ESA1234567A',
            format: /^(ES)?[A-Z0-9]\d{7}[A-Z0-9]$|^EU/,
        },
    },
    FI: {
        business: {
            example: 'FI12345678',
            format: /^FI\d{8}$|^EU/,
        },
    },
    FR: {
        business: {
            example: 'FRAA123456789',
            format: /^FR[A-Z0-9]{2}\d{9}$|^EU/,
        },
    },
    GB: {
        business: {
            example: 'GB123456789',
            format: /^GB\d{9}$|^GB\d{12}$|^GB[A-Z]{2}\d{3}$|^EU/,
        },
    },
    GR: {
        business: {
            example: 'EL123456789',
            format: /^EL\d{9}$/,
        },
    },
    HR: {
        business: {
            example: '12345678901',
            format: /^\d{11}$/,
        },
        private: {
            example: '12345678901',
            format: /^\d{11}$/,
        },
    },
    HU: {
        business: {
            example: 'HU12345678',
            format: /^HU\d{8}$/,
        },
    },
    IE: {
        business: {
            example: 'IE1234567A',
            format: /^IE\d{7}[A-Z]{1,2}$|^IE\d[A-Z]\d{5}[A-Z]$|^IE\d\W\d{5}[A-Z]$|^EU/,
        },
    },
    IL: {
        business: {
            example: '512345678',
            format: /^5[\d]{8}$/,
        },
        private: {
            example: '450401315',
            format: /^\d{9}$/,
        },
    },
    IN: {
        business: {
            example: '22AAAAA0000A1Z5',
            format: /^([0-2][0-9]|[3][0-8])[A-Z]{3}[ABCFGHLJPTK][A-Z]\d{4}[A-Z][A-Z0-9][Z][A-Z0-9]$/,
        },
    },
    IS: {
        business: {
            example: '4504013150',
            format: /^\d{10}$/,
        },
        private: {
            example: '1201743399',
            format: /^\d{10}$/,
        },
    },
    IT: {
        business: {
            example: 'IT12345678901',
            format: /^(IT)?\d{11}$|^EU/,
        },
        private: {
            example: 'BRDBRT83L19F205T',
            format: /^[A-Z0-9]{16}$/,
        },
    },
    LT: {
        business: {
            example: 'LT123456789012',
            format: /^LT\d{9,12}$/,
        },
    },
    LU: {
        business: {
            example: 'LU12345678',
            format: /^LU\d{8}$|^EU/,
        },
    },
    LV: {
        business: {
            example: 'LV12345678901',
            format: /^LV\d{11}$/,
        },
    },
    MT: {
        business: {
            example: 'MT12345678',
            format: /^MT\d{8}$/,
        },
    },
    NL: {
        business: {
            example: 'NL123456789B12',
            format: /^NL\d{9}B\d{2}$|^EU/,
        },
    },
    NO: {
        business: {
            example: 'NO 123 123 123 MVA',
            format: /^(NO)?\s?\d{3}\s?\d{3}\s?\d{3}\s?MVA$/,
        },
    },
    PL: {
        business: {
            example: 'PL1234567890',
            format: /^PL\d{10}$/,
        },
    },
    PT: {
        business: {
            example: 'PT123456789',
            format: /^PT\d{9}$|^EU/,
        },
        private: {
            example: 'PT123456789',
            format: /^PT\d{9}$|^EU/,
        },
    },
    RO: {
        business: {
            example: 'RO12345678',
            format: /^(RO)?\d{4,8}$/,
        },
    },
    SE: {
        business: {
            example: 'SE123456789012',
            format: /^SE\d{12}$|^EU/,
        },
    },
    SG: {
        business: {
            example: '201010405N',
            format: /^[A-Z0-9]{8,9}[A-Z]$/,
        },
    },
    SI: {
        business: {
            example: 'SI12345678',
            format: /^SI\d{8}$/,
        },
    },
    SK: {
        business: {
            example: 'SK1234567890',
            format: /^SK\d{10}$/,
        },
    },
    TH: {
        business: {
            example: '1234567890123',
            format: /^\d{13}$/,
        },
        private: {
            example: '1234567890123',
            format: /^\d{13}$/,
        },
    },
    TR: {
        business: {
            example: '1234567890',
            format: /^\d{10}$/,
        },
        private: {
            example: '12345678950',
            format: /^\d{11}$/,
        },
    },
};
exports.vatBlockList = [
    '100394989600003',
    '133941',
    '178027057',
    '4860276718',
    '516106986',
    '66711429093',
    '82269570741',
    '8400400011',
    'CZ07738315',
    'CZ683677407',
    'DE265761887',
    'DE297265497',
    'DE815850157',
    'EL800938055',
    'FI26449754',
    'FR60524335262',
    'GB237630312',
    'GB784218216',
    'HU29023093',
    'IE3418829SH',
    'LU27919805',
    'MT27655313',
    'NL850516675B01',
    'NL854247452B01',
    'NL855923313B01',
    'NL860250799B01',
    'PL5252776145',
    'PL5263181450',
    'PT514063858',
    'SE556931409801',
    'SI33511721',
    'SI59489880',
    'SK4120062001',
    /^(DK)?32787347$/,
    /^(ES)?B66855701$/,
    /^(IT)?07024150968$/,
    /^(NO)?\s?997\s?433\s?173\s?MVA$/,
    /^(RO)?43602301$/,
    /^AT\s?U67878139$/,
    /^BE\s?0521902461$/,
    /^BE\s?0688857970$/,
    /^CHE-?115\.?498\.?276(\s)?(((HR\/?)?MWST)|((RC\/?)?(TVA|IVA)))?$/,
];
function getVatSettings(countryCode, type) {
    if (countryCode == null || type == null) {
        return null;
    }
    var settings = vatNumberFormatMap[countryCode];
    if (settings == null) {
        console.warn('cannot validate vat number', { countryCode: countryCode });
        return null;
    }
    var specificType = settings[type];
    if (specificType == null) {
        console.warn('cannot validate vat number', { countryCode: countryCode, type: type });
        return null;
    }
    return specificType;
}
var isBlockedVatNumber = function (vatNumber) {
    var blockList = exports.vatBlockList;
    for (var i = 0, j = blockList.length; i < j; i++) {
        var blockListPasses = true;
        var currentBlocker = blockList[i];
        switch (typeof currentBlocker) {
            case 'string': {
                blockListPasses = vatNumber !== currentBlocker;
                break;
            }
            case 'object': {
                blockListPasses = !Boolean(currentBlocker.exec(vatNumber));
                break;
            }
        }
        if (!blockListPasses) {
            return true;
        }
    }
    return false;
};
exports.isBlockedVatNumber = isBlockedVatNumber;
var isvalidVatNumber = function (countryCode, vatNumber, type) {
    var vatSettings = getVatSettings(countryCode, type);
    if (vatNumber == null ||
        (vatSettings !== null && !Boolean(vatSettings === null || vatSettings === void 0 ? void 0 : vatSettings.format.exec(vatNumber)))) {
        return false;
    }
    return !(0, exports.isBlockedVatNumber)(vatNumber);
};
exports.isvalidVatNumber = isvalidVatNumber;
var isValidEUVatNumber = function (vatNumber, type) {
    var countryCodes = Object.keys(vatNumberFormatMap).filter(function (countryCode) {
        return [
            'AT',
            'BE',
            'BG',
            'CH',
            'CY',
            'CZ',
            'DE',
            'DK',
            'EE',
            'EL',
            'ES',
            'FI',
            'FR',
            'GB',
            'HR',
            'HU',
            'IE',
            'IT',
            'LT',
            'LU',
            'LV',
            'MT',
            'NL',
            'NO',
            'PL',
            'PT',
            'RO',
            'SE',
            'SI',
            'SK',
            'TR',
        ].indexOf(countryCode) !== -1;
    });
    for (var i = 0; i < countryCodes.length; i += 1) {
        if ((0, exports.isvalidVatNumber)(countryCodes[i], vatNumber, type)) {
            return true;
        }
    }
    return false;
};
exports.isValidEUVatNumber = isValidEUVatNumber;
var getVatNumberRegex = function (countryCode, type) {
    var vatSettings = getVatSettings(countryCode, type);
    if (vatSettings == null) {
        return /^\w*$/;
    }
    return vatSettings.format;
};
exports.getVatNumberRegex = getVatNumberRegex;
var getVatNumberFormat = function (countryCode, type) {
    var vatSettings = getVatSettings(countryCode, type);
    if (vatSettings == null) {
        return null;
    }
    return vatSettings.example;
};
exports.getVatNumberFormat = getVatNumberFormat;
